import { IcrcLedgerCanister } from '@icp-sdk/canisters/ledger/icrc'
import { HttpAgent } from '@icp-sdk/core/agent'
import { Principal } from '@icp-sdk/core/principal'
import { ApproveParams } from '../../interfaces/walletActions'
import getTokenActor from './getTokenActor'

interface ApproveTokenParams {
  approveParams: ApproveParams
  agent: HttpAgent
}

const approveToken = async ({
  agent,
  approveParams: {
    standard,
    tokenCanisterId,
    expiresAt,
    spender: { address, subaccount },
    amount,
  },
}: ApproveTokenParams) => {
  if (!tokenCanisterId) {
    throw new Error('tokenCanisterId is missing')
  }
  const owner = Principal.fromText(address)

  switch (standard) {
    case 'ICP':
    case 'ICRC2':
    case 'ICRC3':
      const icrcLedger = IcrcLedgerCanister.create({
        agent,
        canisterId: Principal.fromText(tokenCanisterId),
      })

      const approveResponse = await icrcLedger.approve({
        amount: BigInt(amount),
        expires_at: expiresAt ? BigInt(expiresAt) : undefined,
        spender: {
          owner,
          // Candid blobs are Uint8Array in @icp-sdk/canisters; this app carries
          // subaccounts around as number[].
          subaccount: subaccount ? [Uint8Array.from(subaccount)] : [],
        },
      })

      return Number(approveResponse)
    case 'XTC':
      const tokenActor = getTokenActor(tokenCanisterId, standard, agent)

      const response = await tokenActor.xtc?.approve(owner, BigInt(amount))

      if (response && 'Ok' in response) {
        return Number(response.Ok)
      } else {
        throw new Error('Failed to approve XTC')
      }
    default:
      throw new Error('Unsupported token')
  }
}

export default approveToken
